<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        :disabled="salary.status.toUpperCase()!='COMPLETED' && salary.status.toUpperCase()!='CLOSED' ? false:true"
        v-on="on"
      >
        <v-icon medium>
          {{ salary.status.toUpperCase() == 'PENDING' ? 'mdi mdi-close-circle text-danger' : 'mdi mdi-check-circle text-success' }}
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text v-if="salary.status.toUpperCase()=='PENDING'">
        Are you sure you want to change <span class="font-weight-bold">{{ salary.company_employee.employee.person.name }}</span> status to <span class="font-weight-bold info--text">Confirmed</span>?
      </v-card-text>
      <v-card-text v-else-if="salary.status.toUpperCase()=='CONFIRMED'">
        Are you sure you want to revert <span class="font-weight-bold">{{ salary.company_employee.employee.person.name }}</span> status to <span class="font-weight-bold warning--text">Pending</span>?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      salary: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.salaries().update(this.salary.id, this.prepareFormData())
          .then(res => {
            this.$emit('updated')
            this.$snack({ message: 'Salary status succesfully updated' })
            this.menu = false
            this.setProgressing(false)
          }).catch(() => {
            this.$snack({ 
              color: 'error',
              message: 'Failed to update salary status', 
            })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          status: this.salary.status.toUpperCase() === 'PENDING' ? 'Confirmed' : 'Pending',
        }
      },
    },
  }
</script>
